import { render, staticRenderFns } from "./HeadingRichText.vue?vue&type=template&id=ece3ade8&scoped=true&"
import script from "./HeadingRichText.vue?vue&type=script&lang=js&"
export * from "./HeadingRichText.vue?vue&type=script&lang=js&"
import style0 from "./HeadingRichText.vue?vue&type=style&index=0&id=ece3ade8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece3ade8",
  null
  
)

export default component.exports